
<script>

    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    let customers_count = 0,
        door_count = 0,
        pickup_count = 0;

    $: shipments_count = door_count + pickup_count;


    onMount(async() => {

        // const ctx = document.getElementById('myChart');

        // const data = {
        //     datasets: [
        //         {
        //             label: '',
        //             data: [
        //                     {
        //                         x: 0,
        //                         y: 1
        //                     }, 
        //                     {
        //                         x: 1,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 2,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 3,
        //                         y: 4
        //                     }, 
        //                     {
        //                         x: 4,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 5,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 6,
        //                         y: 1
        //                     }, 
        //                     {
        //                         x: 7,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 8,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 9,
        //                         y: 4
        //                     }, 
        //                     {
        //                         x: 10,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 11,
        //                         y: 3
        //                     }
        //             ],
        //             backgroundColor: '#ca171e',
        //             borderColor: '#ca171e',
        //             color: '#ca171e',
        //             hoverBorderWidth:2
        //         }
        //     ],
        // };

        // const config = {
        //     type: 'bubble',
        //     data: data,
        //     options: {
        //         animations: {
        //             tension: {
        //                 duration: 1000,
        //                 easing: 'linear',
        //                 from: 1,
        //                 to: 0,
        //                 loop: true
        //             }
        //         },
        //         layout: {
        //             padding: 1
        //         },
        //         responsive: true,
        //         plugins: {
        //             tooltip : {
        //                 enabled : false
        //             },
        //             legend: {
        //                 position: 'top',
        //                 display: false,
        //             },
        //             title: {
        //                 display: false,
        //                 text: 'Chart.js Scatter Chart'
        //             }
        //         }
        //     },
        // };

        // new Chart(ctx, config);

    });

</script>
<div class="dash-top">
    <div class="box">
        <div><i class="fa-solid fa-chart-simple"></i> {$_('dash.statics')}</div>
    </div>
    <div class="box">
        <div>{$_('dash.shipments')}</div>
        <div>{shipments_count}</div>
        <!-- <div class="canvas-container">
            <canvas id="myChart"></canvas>
        </div> -->
    </div>
    <div class="box">
        <div>{$_('dash.returns')}</div>
        <div>{customers_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
    <div class="box">
        <div>{$_('dash.door')}</div>
        <div>{door_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
    <div class="box">
        <div>{$_('dash.pickup')}</div>
        <div>{pickup_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
</div>
<style>
    .canvas-container {
        width: 200px;;
        height: 70px;
    }
    .dash-top{
        display: flex;
        gap:20px;
        justify-content: space-between;
        box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
        background-color: #fff;;
        z-index: 1;
        position: fixed;
        top: 0;
        width: calc(100% - 200px);        
    }
    .dash-top .box{
        border-radius: 7px;
        /* border: 1px solid #e4e4e4;
        border: 3px solid rgb(244, 247, 249); */
        padding:10px 20px;
        width: 200px;
        text-align: center;
        background-color: #fff;;
        font-size:15px;      
        display: flex;
        gap:10px;  
    }
    /* .dash-top .box > div:last-child {
        font-size:20px;
    } */
</style>